import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_MENTIONS,
     ADD_NEW_MENTION, 
     UPDATE_MENTION, 
     DELETE_MENTION 
    } from "./actionTypes";
import {
    getMentionsSuccess,
    getMentionsFail,
    addMentionSuccess,
    addMentionFail,
    updateMentionSuccess,
    updateMentionFail,
    deleteMentionSuccess,
    deleteMentionFail,
   
} from "./actions"

import {
    getMentions,
    addNewMention,
    updateMention,
    deleteMention,
   
} from "helpers/mentions/mentions_backend_helper";
import { toast } from "react-toastify";

function* fetchMentions() {
    try {
        const response = yield call(getMentions)
        yield put(getMentionsSuccess(response))
    } catch (error) {
        yield put(getMentionsFail(error))
    }
}

function* onAddNewMention({ payload }) {
    try {

        
        const response = yield call(addNewMention, payload)

        console.log("RESPONSE:", response);
        yield put(addMentionSuccess(response.mention))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addMentionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateMention({ payload: data }) {
    try {
        const response = yield call(updateMention, data)
        yield put(updateMentionSuccess(response))
        toast.success("department  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateMentionFail(error))
        toast.error("department  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateMention({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateMention, payload)
        yield put(updateMentionSuccess(response.mention))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateMentionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteMention({ payload: data }) {

    try {
        const response = yield call(deleteMention, data)
        yield put(deleteMentionSuccess(response.mentionId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteMentionFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* mentionSaga() {
    yield takeEvery(GET_MENTIONS, fetchMentions)
    yield takeEvery(ADD_NEW_MENTION, onAddNewMention)
    yield takeEvery(UPDATE_MENTION, onUpdateMention)
    yield takeEvery(DELETE_MENTION, onDeleteMention)
}

export default mentionSaga;